---
title: Notifications
lede: How a session that runs while you do something else tells you it stopped.
order: 11
part: Find your way
---

Airlock posts a system notification when a session needs you or has finished. Choose which in **Settings › Notifications**; a workspace can answer for itself in **Workspace settings › Notifications**.

![Notification settings](media/settings-notifications.webp)

### The setting

**Interrupt me when a session**:

| Answer | You are notified |
|---|---|
| **Finished, and anything stopped** (default) | Every handback and every stop |
| **Only what is stopped** | Only when a person is needed |
| **Never** | Never |

**Stopped** means the agent is waiting on an answer or an approval, or for you to accept something it asked, a [workflow](/workflows) step is parked at its gate, a connection is waiting on an [egress](/network) decision, a task stalled before it could start, or a session failed. **Finished** means the agent handed back and its changes are ready to review.

### How they behave

- Nothing is shown while the Airlock window has focus.
- Repeats about the same session are held for a minute.
- Starting Airlock does not notify about sessions that were already waiting.
- Only a failure plays a sound.
- A workflow's **Notifies you** step posts its own message whatever the setting says, and it is never held back as a repeat. With the window in focus it is a toast instead.

### Clicking one

The window comes forward and opens the session the notification is about, or its workspace when a task has no session yet.

### The dock badge

On macOS the dock icon shows how many sessions are stopped for a person, across every workspace, and bounces once with each notification. The badge does not depend on the setting above.
